module.exports = __webpack_public_path__ + "media/images/easy-to-avail-4945ddffceacaf27bae7d26ab35a2964.svg";